import {
  FrequencyUnit,
  PlannedOccurrence,
  ScheduleEntryState,
} from 'shared/types/habit-schedule';
import { Timestamp } from 'shared/types/timestamp';

export type UpcomingPeriodDay = {
  date: Timestamp;
  entry?: DayEntry;
};
export enum UpcomingPeriodTypes {
  Overdue = 'overdue',
}

export type UpcomingPeriod = {
  date: Timestamp;
  days: UpcomingPeriodDay[];
  type: FrequencyUnit | UpcomingPeriodTypes;
};

export type DayEntry = PlannedOccurrence & {
  isGeneratedFrequencyEntry: boolean;
  isUnplannedEntry: boolean;
  state?: ScheduleEntryState;
  hidden?: boolean;
};
